import React from 'react';

import * as S from './styles';

function CardDefault({ title, actionsIcons }) {
    return (
        <S.Container>
            <S.Card>
                <S.AttachContainer>
                    <S.LeftContent>
                        <S.Content>
                            <span>{title}</span>
                        </S.Content>
                    </S.LeftContent>
                    <S.Actions>{actionsIcons}</S.Actions>
                </S.AttachContainer>
            </S.Card>
        </S.Container>
    );
}

export default CardDefault;
